export const bodyRepairServices = [
  {
    title: 'Відновлення після ДТП',
    description:
      'Повний цикл: від дефектовки та відновлення геометрії до видачі готового авто.',
  },
  {
    title: 'Рихтування кузова',
    description:
      'Усуваємо вм\u2019ятини та деформації панелей, повертаємо заводську форму.',
  },
  {
    title: 'Фарбування елементів',
    description:
      'Підбір кольору під ваш автомобіль, локальне або повне фарбування деталей.',
  },
  {
    title: 'Заміна кузовних деталей',
    description:
      'Крила, бампери, двері, капот — підбір, підгонка та встановлення.',
  },
]

export const bodyRepairSteps = [
  {
    title: 'Огляд авто',
    description: 'Фіксуємо всі пошкодження, включно з прихованими.',
  },
  {
    title: 'Кошторис',
    description: 'Узгоджуємо обсяг робіт і вартість до початку ремонту.',
  },
  {
    title: 'Ремонт',
    description: 'Рихтування, підготовка та фарбування зі звітом по етапах.',
  },
  {
    title: 'Видача',
    description: 'Перевіряємо результат разом з вами при денному світлі.',
  },
]
